import React from 'react';
import {Divider as MUIDivider} from "@material-ui/core";

export const Divider = ({themeMode}) => {
    return (
        <MUIDivider/>
    )
}